import admin_ar from './locales/ar/admin.json';
import auth_ar from './locales/ar/auth.json';
import chat_ar from './locales/ar/chat.json';
import common_ar from './locales/ar/common.json';
import coupon_ar from './locales/ar/coupon.json';
import home_ar from './locales/ar/home.json';
import legal_ar from './locales/ar/legal.json';
import nav_ar from './locales/ar/navigation.json';
import public_ar from './locales/ar/public.json';
import quiz_ar from './locales/ar/quiz.json';
import teach_ar from './locales/ar/teach.json';
import admin_en from './locales/en/admin.json';
import auth_en from './locales/en/auth.json';
import chat_en from './locales/en/chat.json';
import common_en from './locales/en/common.json';
import coupon_en from './locales/en/coupon.json';
import home_en from './locales/en/home.json';
import legal_en from './locales/en/legal.json';
import nav_en from './locales/en/navigation.json';
import public_en from './locales/en/public.json';
import quiz_en from './locales/en/quiz.json';
import teach_en from './locales/en/teach.json';

const resources = {
  en: {
    common: common_en,
    auth: auth_en,
    home: home_en,
    navigation: nav_en,
    chat: chat_en,
    quiz: quiz_en,
    coupon: coupon_en,
    admin: admin_en,
    teach: teach_en,
    legal: legal_en,
    public: public_en
  },
  ar: {
    common: common_ar,
    auth: auth_ar,
    home: home_ar,
    navigation: nav_ar,
    chat: chat_ar,
    quiz: quiz_ar,
    coupon: coupon_ar,
    admin: admin_ar,
    teach: teach_ar,
    legal: legal_ar,
    public: public_ar
  }
};

export default resources;
